import React from "react";
import { renderContent } from "../../utilities/renderContent";
import { graphql } from "gatsby";

export default function KeyBenefitsSection({ data }) {
  const {
    benefitBody1,
    benefitBody2,
    benefitBody3,
    benefitHeading1,
    benefitHeading2,
    benefitHeading3,
    benefitIcon1,
    benefitIcon2,
    benefitIcon3,
  } = data;
  const textBlocks = [
    { heading: benefitHeading1, body: benefitBody1, icon: benefitIcon1 },
    { heading: benefitHeading2, body: benefitBody2, icon: benefitIcon2 },
    { heading: benefitHeading3, body: benefitBody3, icon: benefitIcon3 },
  ];

  return (
    <section className="relative z-10 hds-container hds-text-color key-benefits-bg">
      <div className="hds-section">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {textBlocks.map((block, i) => (
            <div
              key={`${block.heading}${i}`}
              className={`flex flex-col text-center py-6 px-3 relative z-0 hds-transition stagger-item stagger-up is-showing`}
            >
              <h6 className="text-2xl md:text-xl lg:text-2xl font-bold leading-none font-heading text-white uppercase">
                {block.heading}
              </h6>
              <img
                className="w-full h-24 self-center py-2"
                src={block.icon.url}
                alt={block.icon.alt}
              />
              <div
                className="key-benefits__body-text"
                dangerouslySetInnerHTML={renderContent(block.body)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export const keyBenefitsQuery = graphql`
  fragment KeyBenefitsComponent on DatoCmsKeyBenefitsSection {
    internal {
      type
    }
    id
    sectionHeading
    benefitHeading1
    benefitHeading2
    benefitHeading3
    benefitBody1
    benefitBody2
    benefitBody3
    benefitIcon1 {
      alt
      url
    }
    benefitIcon2 {
      alt
      url
    }
    benefitIcon3 {
      alt
      url
    }
  }
`;
